<template>
    <!-- Main Content -->
    <div class="main-content">
      <section class="section">
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="card card-statistic-2">
              <div class="card-stats">
                <div class="card-stats-title">Statistik Penjualan -
                  <div class="dropdown d-inline mr-2 ml-1">
                    <a href="#" data-toggle="dropdown" class="font-weight-600 dropdown-toggle">{{ statistikLabel }}</a>
                    <ul class="dropdown-menu dropdown-menu-sm">
                      <li class="dropdown-title">Select Year</li>
                      <li v-for="(stP,i) in statistikPeriod" :key="i"><a @click="setStatistikYear(i)" class="dropdow-item">{{ stP.label }}</a></li>
                    </ul>
                  </div>
                  <div class="dropdown d-inline">
                    <a class="font-weight-600 dropdown-toggle" data-toggle="dropdown" href="#" id="orders-month">{{ statMonth }}</a>
                    <ul class="dropdown-menu dropdown-menu-sm">
                      <li class="dropdown-title">Select Month</li>
                      <li v-for="(mn,index) in monthName" :key="index"><a @click="setOrderMonth(index)" class="dropdown-item">{{ mn }}</a></li>
                    </ul>
                  </div>
                </div>
                <div class="card-stats-items">
                  <div class="card-stats-item">
                    <div class="card-stats-item-count">{{ statistik.pemesanan }}</div>
                    <div class="card-stats-item-label">Pemesanan</div>
                  </div>
                  <div class="card-stats-item">
                    <div class="card-stats-item-count">{{ statistik.pengiriman }}</div>
                    <div class="card-stats-item-label">Pengiriman</div>
                  </div>
                  <div class="card-stats-item">
                    <div class="card-stats-item-count">{{ statistik.pembayaran }}</div>
                    <div class="card-stats-item-label">Pembayaran</div>
                  </div>
                </div>
              </div>
              <div class="card-icon shadow-primary bg-primary">
                <i class="fas fa-archive"></i>
              </div>
              <div class="card-wrap">
                <div class="card-header">
                  <h4>Total Penjualan</h4>
                </div>
                <div class="card-body">
                  {{ statistik.total_order }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="card card-statistic-2">
              <div class="card-chart">
                <canvas ref="balance-chart" id="balance-chart" height="80"></canvas>
              </div>
              <div class="card-icon shadow-primary bg-primary">
                <i class="fas fa-dollar-sign"></i>
              </div>
              <div class="card-wrap">
                <div class="card-header">
                  <h4>Kas</h4>
                </div>
                <div class="card-body">
                  $187,13
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="card card-statistic-2">
              <div class="card-chart">
                <canvas id="sales-chart" height="80"></canvas>
              </div>
              <div class="card-icon shadow-primary bg-primary">
                <i class="fas fa-shopping-bag"></i>
              </div>
              <div class="card-wrap">
                <div class="card-header">
                  <h4>Penjualan</h4>
                </div>
                <div class="card-body">
                  {{ totalPenjualan.total_penjualan }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8">
            <div class="card">
              <div class="card-header">
                <h4>Pembelian vs Penjualan</h4>
                <div class="card-header-action dropdown">
                  <a href="#" data-toggle="dropdown" class="btn btn-danger dropdown-toggle">{{ pembelianPenjualanLabel }}</a>
                  <ul class="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                    <li class="dropdown-title">Select Period</li>
                    <li v-for="(pPr,i) in ppPeriod" :key="i"><a @click="setPembelianPenjualan(i)" class="dropdow-item" :class="{ active : ppVal == pPr.val}">{{ pPr.label }}</a></li>
                  </ul>
                </div>
              </div>
              <div class="card-body">
                <canvas ref="myChart" id="myChart" height="158"></canvas>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card gradient-bottom">
              <div class="card-header">
                <h4>Top 5 Produk</h4>
                <div class="card-header-action dropdown">
                  <a href="#" data-toggle="dropdown" class="btn btn-danger dropdown-toggle">{{ topPeriodLabel }}</a>
                  <ul class="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                    <li class="dropdown-title">Select Period</li>
                    <li v-for="(pr,i) in period" :key="i"><a @click="setTopProduk(i)" class="dropdow-item" :class="{ active : topPeriodVal == pr.val}">{{ pr.label }}</a></li>
                  </ul>
                </div>
              </div>
              <div class="card-body" id="top-5-scroll" style="height:500px !important;">
                <ul class="list-unstyled list-unstyled-border">
                  <li v-for="prod in top5" :key="prod.detail.id_produk" class="media">
                    <img class="mr-3 rounded" width="55" src="../assets/img/products/product-5-50.png" alt="product">
                    <div class="media-body">
                      <div class="float-right"><div class="font-weight-600 text-muted text-small">{{ parseFloat(prod.detail.total_qty_sold).toFixed(1) }} {{ prod.detail.nama_satuan }} Penjualan</div></div>
                      <div class="media-title">{{ prod.detail.nama_produk }}</div>
                      <div class="mt-1">
                        <div class="budget-price">
                          <div class="budget-price-square bg-primary" :data-width="((prod.avg_jual/topSell)*100)+'%'"></div>
                          <div class="budget-price-label">Rp. {{ $parent.currencyFormat(prod.avg_jual) }}</div>
                        </div>
                        <div class="budget-price">
                          <div class="budget-price-square bg-danger" :data-width="((prod.avg_beli/topBuy)*100)+'%'"></div>
                          <div class="budget-price-label">Rp. {{ $parent.currencyFormat(prod.avg_beli) }}</div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="card-footer pt-3 d-flex justify-content-center">
                <div class="budget-price justify-content-center">
                  <div class="budget-price-square bg-primary" data-width="20"></div>
                  <div class="budget-price-label">Harga Jual Rata-Rata</div>
                </div>
                <div class="budget-price justify-content-center">
                  <div class="budget-price-square bg-danger" data-width="20"></div>
                  <div class="budget-price-label">Harga Beli Rata-Rata</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4>Bad Debt Penjualan Hari Ini</h4>
              </div>
              <div class="card-body p-0">
                <canvas ref="badDebtChart" id="badDebtChart" height="120" ></canvas>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4>Top 7 Piutang Customer</h4>
              </div>
              <div class="card-body p-0">
                <canvas ref="customerDebtChart" id="customerDebtChart" height="120" ></canvas>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4>Invoices</h4>
                <div class="card-header-action">
                  <button @click="showMoreInvoices()" class="btn btn-danger">View More <i class="fas fa-chevron-right"></i></button>
                </div>
              </div>
              <div class="card-body p-0">
                <div class="table-responsive table-invoice">
                  <table class="table table-striped">
                    <tr>
                      <th>Invoice ID</th>
                      <th>Customer</th>
                      <th>Status</th>
                      <th>Due Date</th>
                      <th>Action</th>
                    </tr>
                    <tr v-for="(inv) in dataInvoices" :key="inv.id_transaksi_pembayaran">
                      <td><a href="javascript:" @click.prevent="goDetail(inv.id_transaksi_pembayaran,inv.jenis_pembayaran)">{{ inv.nomor_invoice }}</a></td>
                      <td class="font-weight-600">{{ inv.display_name }}</td>
                      <td><div class="badge badge-warning">Belum Dibayar</div></td>
                      <td>{{ inv.tanggal_jatuh_tempo_pembayaran | moment("DD MMMM YYYY") }}</td>
                      <td>
                        <a href="javascript:" @click.prevent="goDetail(inv.id_transaksi_pembayaran,inv.jenis_pembayaran)" class="btn btn-primary">Detail</a>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
</template>
<script>
import Chart from 'chart.js';
import carousel from 'vue-owl-carousel'

export default {
  data() {
    return {
      workspace : null,
      statistik : [],
      statistikMonth : '',
      statMonth : '',
      monthName : ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"],
      monthNum : ["01","02","03","04","05","06","07","08","09","10","11","12"],
      tahun : '',
      totalPenjualan : [],
      penjualanPembelian : [],
      topPeriodLabel : 'Bulan ini',
      topPeriodVal : 'bulan',
      period : [
        {
          label : 'Tahun Lalu',
          val : 'tahun_lalu'
        },
        {
          label : 'Bulan ini',
          val : 'bulan'
        },
        {
          label : 'Tahun ini',
          val : 'tahun'
        },
      ],
      pembelianPenjualanLabel : new Date().getFullYear(),
      ppVal : new Date().getFullYear(),
      ppPeriod : [

      ],
      statistikLabel : new Date().getFullYear(),
      statistikVal : new Date().getFullYear(),
      statistikPeriod : [

      ],
      top5 : [],
      topBuy : 0,
      topSell : 0,
      totalDataInvoices : 5,
      dataInvoices : []

    }
  },
  mounted() {
    var today = new Date();
    this.tahun = today.getFullYear()
    this.statistikMonth = this.statistikVal+'-'+this.monthNum[today.getMonth()]
    this.statMonth = this.monthName[today.getMonth()]
    this.init();
  },
  methods: {
    init: function() {
      this.getStatistikPenjualan()
      this.getKasBesar()
      this.getTotalPenjualan()
      this.getPembelianPenjualan()
      this.getTop5()
      this.getInvoices()
      this.getBadDebt();
      this.getCustomerPiutang();

      var year = new Date().getFullYear();
      var firstYear = 2019

      for(;year >= firstYear ; year--)
      {
        this.ppPeriod.push(
          {
            label : year,
            val : year
          }
        )
        this.statistikPeriod.push(
          {
            label : year,
            val : year
          }
        )
      }

    },
    getBadDebt: function() {
      let that = this;
      this.$http.get("Laporan/badDebt").then(response => {
        if (response.data.code == "01") {
          this.badDeb = response.data.detail;
          var ctx = document.getElementById("badDebtChart").getContext("2d");
          var myChart = new Chart(ctx, {
            type: "horizontalBar",
            data: {
              labels: this.badDeb["label"],
              datasets: [
                {
                  label: "in IDR",
                  data: this.badDeb["series"],
                  borderWidth: 2,
                  backgroundColor: [
                    "rgba(54, 162, 235, 0.2)",
                    "rgba(255, 99, 132, 0.2)"
                  ],
                  borderWidth: 0,
                  borderColor: "transparent",
                  pointBorderWidth: 0,
                  pointRadius: 3.5,
                  pointBackgroundColor: "transparent"
                },
                {
                  label: "Jatuh Tempo > 3 Bulan",
                  data: this.badDeb["series2"],
                  borderWidth: 2,
                  backgroundColor: [
                    "rgba(54, 162, 235, 0.2)",
                    "rgba(254,86,83,.7)"
                  ],
                  borderWidth: 0,
                  borderColor: "transparent",
                  pointBorderWidth: 0,
                  pointRadius: 3.5,
                  pointBackgroundColor: "transparent"
                }
              ]
            },
            options: {
              tooltips: {
                callbacks: {
                  label: function(t, d) {
                    var xLabel = d.datasets[t.datasetIndex].label;
                    var yLabel = "Rp." + that.$parent.currencyFormat(t.xLabel);
                    return xLabel + " : " + yLabel;
                  }
                }
              },
              legend: {
                display: false
              },
              scales: {
                xAxes: [
                  {
                    gridLines: {
                      // display: false,
                      drawBorder: false,
                      color: "#f2f2f2"
                    },
                    ticks: {
                      beginAtZero: true,
                      // stepSize: 50000000,
                      callback: function(value, index, values) {
                        return "Rp." + that.$parent.currencyFormat(value);
                      }
                    }
                  }
                ],
                yAxes: [
                  {
                    stacked: true,
                    gridLines: {
                      display: false,
                      tickMarkLength: 15
                    }
                  }
                ]
              }
            }
          });
        } else {
          alert("failed to get Bad Debt");
        }
      });
    },
    getCustomerPiutang: function() {
      let that = this;
      this.$http.get("Laporan/executiveDebt").then(response => {
        if (response.data.code == "01") {
          this.badDeb = response.data.detail;
          var ctx = document
            .getElementById("customerDebtChart")
            .getContext("2d");
          var myChart = new Chart(ctx, {
            type: "bar",
            data: {
              labels: this.badDeb["label"],
              datasets: [
                {
                  label: "Jatuh Tempo",
                  data: this.badDeb["series"]["invoice"],
                  borderWidth: 2,
                  backgroundColor: "rgba(255, 99, 132, 0.2)",
                  borderWidth: 0,
                  borderColor: "transparent",
                  pointBorderWidth: 0,
                  pointRadius: 3.5,
                  pointBackgroundColor: "transparent"
                },
                {
                  label: "Jatuh Tempo Lebih Dari 3 Bulan",
                  data: this.badDeb["series"]["jatuhTempo"],
                  borderWidth: 2,
                  backgroundColor: "rgba(254,86,83,.7)",
                  borderWidth: 0,
                  borderColor: "transparent",
                  pointBorderWidth: 0,
                  pointRadius: 3.5,
                  pointBackgroundColor: "transparent"
                }
              ]
            },
            options: {
              tooltips: {
                callbacks: {
                  label: function(t, d) {
                    var xLabel = d.datasets[t.datasetIndex].label;
                    var yLabel =
                      t.yLabel >= 1000
                        ? "Rp. " +
                          t.yLabel
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "Rp. " + t.yLabel;
                    return xLabel + " : " + yLabel;
                  }
                }
              },
              legend: {
                display: true
              },
              scales: {
                yAxes: [
                  {
                    gridLines: {
                      // display: false,
                      drawBorder: false,
                      color: "#f2f2f2"
                    },
                    ticks: {
                      beginAtZero: true,
                      // stepSize: 50000000,
                      callback: function(value, index, values) {
                        return "Rp." + that.$parent.currencyFormat(value);
                      }
                    }
                  }
                ],
                xAxes: [
                  {
                    stacked: true,
                    gridLines: {
                      display: false,
                      tickMarkLength: 15
                    }
                  }
                ]
              }
            }
          });
        } else {
          alert("failed to get Customer Debt");
        }
      });
    },
    getStatistikPenjualan: function() {
      this.$http.get('Laporan/getStatistikPenjualan/'+this.statistikMonth).then(result => {
        if(result.data.code == '01') {
          this.statistik = result.data.detail
        }else {
          alert('failed to get statistik')
        }
      }, error => {
        context.error = error
      })
    },
    getKasBesar: function() {
      var balance_chart = document.getElementById("balance-chart").getContext('2d');

      var balance_chart_bg_color = balance_chart.createLinearGradient(0, 0, 0, 70);
      balance_chart_bg_color.addColorStop(0, 'rgba(63,82,227,.2)');
      balance_chart_bg_color.addColorStop(1, 'rgba(63,82,227,0)');

      var myChart = new Chart(balance_chart, {
        type: 'line',
        data: {
          labels: ['16-07-2018', '17-07-2018', '18-07-2018', '19-07-2018', '20-07-2018', '21-07-2018', '22-07-2018', '23-07-2018', '24-07-2018', '25-07-2018', '26-07-2018', '27-07-2018', '28-07-2018', '29-07-2018', '30-07-2018', '31-07-2018'],
          datasets: [{
            label: 'Balance',
            data: [50, 61, 80, 50, 72, 52, 60, 41, 30, 45, 70, 40, 93, 63, 50, 62],
            backgroundColor: balance_chart_bg_color,
            borderWidth: 3,
            borderColor: 'rgba(63,82,227,1)',
            pointBorderWidth: 0,
            pointBorderColor: 'transparent',
            pointRadius: 3,
            pointBackgroundColor: 'transparent',
            pointHoverBackgroundColor: 'rgba(63,82,227,1)',
          }]
        },
        options: {
          layout: {
            padding: {
              bottom: -1,
              left: -1
            }
          },
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              gridLines: {
                display: false,
                drawBorder: false,
              },
              ticks: {
                beginAtZero: true,
                display: false
              }
            }],
            xAxes: [{
              gridLines: {
                drawBorder: false,
                display: false,
              },
              ticks: {
                display: false
              }
            }]
          },
        }
      });
    },
    getTotalPenjualan: function() {
      this.$http.get('Laporan/getTotalPenjualan/'+this.tahun).then(result => {
        if(result.data.code == '01') {
          this.totalPenjualan = result.data.detail

          var sales_chart = document.getElementById("sales-chart").getContext('2d');

          var sales_chart_bg_color = sales_chart.createLinearGradient(0, 0, 0, 70);
          sales_chart_bg_color.addColorStop(0, 'rgba(63,82,227,.2)');
          sales_chart_bg_color.addColorStop(1, 'rgba(63,82,227,0)');

          var myChart = new Chart(sales_chart, {
            type: 'line',
            data: {
              labels: this.totalPenjualan['label'],
              datasets: [{
                label: 'Sales',
                data: this.totalPenjualan['data'],
                borderWidth: 2,
                backgroundColor: sales_chart_bg_color,
                borderWidth: 3,
                borderColor: 'rgba(63,82,227,1)',
                pointBorderWidth: 0,
                pointBorderColor: 'transparent',
                pointRadius: 3,
                pointBackgroundColor: 'transparent',
                pointHoverBackgroundColor: 'rgba(63,82,227,1)',
              }]
            },
            options: {
              layout: {
                padding: {
                  bottom: -1,
                  left: -1
                }
              },
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  gridLines: {
                    display: false,
                    drawBorder: false,
                  },
                  ticks: {
                    beginAtZero: true,
                    display: false
                  }
                }],
                xAxes: [{
                  gridLines: {
                    drawBorder: false,
                    display: false,
                  },
                  ticks: {
                    display: false
                  }
                }]
              },
            }
          });
        }else {
          alert('failed to get total penjualan')
        }
      }, error => {
        context.error = error
      })
    },
    getPembelianPenjualan: function() {
      let that = this
      this.$http.get('Laporan/getPembelianPenjualan/'+this.ppVal).then(result => {
        if(result.data.code == '01') {
          this.penjualanPembelian = result.data.detail
          var ctx = document.getElementById("myChart").getContext('2d');
          var myChart = new Chart(ctx, {
            type: 'bar',
            data: {
              labels: this.penjualanPembelian['label'],
              datasets: [{
                label: 'Penjualan',
                data: this.penjualanPembelian['penjualan'],
                borderWidth: 2,
                backgroundColor: 'rgba(63,82,227,.8)',
                borderWidth: 0,
                borderColor: 'transparent',
                pointBorderWidth: 0,
                pointRadius: 3.5,
                pointBackgroundColor: 'transparent',
                pointHoverBackgroundColor: 'rgba(63,82,227,.8)',
              },
              {
                label: 'Pembelian',
                data: this.penjualanPembelian['pembelian'],
                borderWidth: 2,
                backgroundColor: 'rgba(254,86,83,.7)',
                borderWidth: 0,
                borderColor: 'transparent',
                pointBorderWidth: 0 ,
                pointRadius: 3.5,
                pointBackgroundColor: 'transparent',
                pointHoverBackgroundColor: 'rgba(254,86,83,.8)',
              }]
            },
            options: {
              tooltips: {
                callbacks: {
                    label: function(t, d) {
                      var xLabel = d.datasets[t.datasetIndex].label;
                      var yLabel = t.yLabel >= 1000 ? 'Rp. ' + t.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'Rp. ' + t.yLabel;
                      return xLabel + ' : ' + yLabel;
                    }
                }
              },
              legend: {
                display: false
              },
              scales: {
                yAxes: [{
                  gridLines: {
                    // display: false,
                    drawBorder: false,
                    color: '#f2f2f2',
                  },
                  ticks: {
                    beginAtZero: true,
                    // stepSize: 50000000,
                    callback: function(value, index, values) {
                      return 'Rp.' + that.$parent.currencyFormat(value);
                    }
                  }
                }],
                xAxes: [{
                  gridLines: {
                    display: false,
                    tickMarkLength: 15,
                  }
                }]
              },
            }
          });
        }else {
          alert('failed to get penjualan x pembelian')
        }
      }, error => {
        context.error = error
      })


    },
    getTop5: function() {
      this.$http.get('Laporan/getTopProducts/5/'+this.topPeriodVal).then(result => {
        if(result.data.code == '01') {
          this.top5 = result.data.detail.produk
          this.topBuy = result.data.detail.top_beli
          this.topSell = result.data.detail.top_jual
        }else {
          alert('failed to get Top 5')
        }
      }, error => {
        context.error = error
      })
    },
    getTopProduct: function() {

    },
    getInvoices: function() {
      this.$http.get('Laporan/getInvoices/'+this.totalDataInvoices).then(result => {
        if(result.data.code == '01') {
          this.dataInvoices = result.data.detail.invoices
        }else {
          alert('failed to get Invoices')
        }
      }, error => {
        context.error = error
      })
    },
    setOrderMonth: function(val) {
      var today = new Date();
      this.statistikMonth = this.statistikVal+'-'+this.monthNum[val]
      this.statMonth = this.monthName[val]
      this.getStatistikPenjualan();
    },
    setTopProduk: function(index) {
      this.topPeriodVal = this.period[index].val
      this.topPeriodLabel = this.period[index].label
      this.getTop5();
    },
    goDetail: function(id_transaksi,type){
        var u = '/penjualan/list/pembayaran-penjualan';
        this.$router.push({ path : u+'-detail/'+id_transaksi+'/'+type })
    },
    showMoreInvoices: function() {
      this.totalDataInvoices = this.totalDataInvoices + 5;
      this.getInvoices()
    },
    setPembelianPenjualan: function(index)
    {
      this.ppVal = this.ppPeriod[index].val
      this.pembelianPenjualanLabel = this.ppPeriod[index].label
      this.getPembelianPenjualan();
    },
    setStatistikYear: function(index)
    {
      this.statistikVal = this.statistikPeriod[index].val
      this.statistikLabel = this.statistikPeriod[index].label
      var statistikPeriod = this.statistikMonth.split("-");
      this.statistikMonth = this.statistikVal+'-'+statistikPeriod[1]
      this.getStatistikPenjualan();
    }
  },
  components: {
    carousel
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue